import { Draggable } from '@hello-pangea/dnd';
import { Control, UseFormRegister } from 'react-hook-form';

import config from '../../../config';
import { InquiryForm, InquiryItem } from '../../../models/Inquiry/Inquiry';
import FormContentChildren from './FormContentItemChildren';

interface Props {
  item: InquiryItem
  index: number
  register: UseFormRegister<InquiryForm>
  control: Control<InquiryForm, any>
  onRemove: (id: number) => void
  disabled: boolean
}

export default function FormContentItem({
  item, index, register, control, onRemove, disabled,
}: Props) {
  if (item.type === config.items.types.group.value) {
    return (
      <Draggable
        key={item.uuid}
        draggableId={String(item.uuid)}
        index={index}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{ ...provided.draggableProps.style }}
            className="user-select-none list-group-item list-group-item-action gap-2"
          >
            <div className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center justify-content-between">
                <div className="flex-fill">
                  <i className="fa-solid fa-bars fa-fw me-2" />
                  <span className="fw-bold notranslate" translate="no">{item.label}</span>
                </div>
                <div className="controls">
                  <button type="button" className="btn-close" aria-label="Close" onClick={() => { onRemove(index); }} />
                </div>
              </div>
              <FormContentChildren
                fieldIndex={index}
                register={register}
                control={control}
                disabled={disabled}
              />
            </div>
          </div>
        )}
      </Draggable>
    );
  }

  return (
    <Draggable
      key={item.uuid}
      draggableId={String(item.uuid)}
      index={index}
    >
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{ ...provided.draggableProps.style }}
          className="user-select-none list-group-item list-group-item-action gap-2"
        >
          <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="flex-fill">
                <i className="fa-solid fa-bars fa-fw me-2" />
                <span className="fw-bold notranslate" translate="no">{item.label}</span>
              </div>
              <div className="controls">
                <button type="button" className="btn-close" aria-label="Close" onClick={() => { onRemove(index); }} />
              </div>
            </div>
            <div className="d-flex flex-column option-item">
              <div className="d-flex flex-wrap align-items-center col-gap-3">
                <div className="form-check form-switch">
                  <input
                    id={`required_${item.id}`}
                    key={item.id}
                    {...register(`definition.${index}.required`)}
                    type="checkbox"
                    className="form-check-input"
                    disabled={disabled}
                  />
                  <label className="form-check-label" htmlFor={`required_${item.id}`}>Required field</label>
                </div>
              </div>
            </div>
            <div className="d-flex flex-column option-info">
              <div className="d-flex flex-wrap align-items-center gap-2">
                <div className="text-sm">
                  Item type:
                  {' '}
                  <span>{Object.values(config.items.types).find((i) => i.value === item?.type)?.label}</span>
                </div>
                <div className="text-sm">
                  Item placeholder:
                  {' '}
                  <span translate="no" className="notranslate">{item?.placeholder || 'None'}</span>
                </div>
                {
                  [
                    config.items.types.text.value,
                    config.items.types.textarea.value,
                    config.items.types.date.value,
                    config.items.types.checkbox.value,
                    config.items.types.select.value,
                    config.items.types.number.value,
                    config.items.types.email.value,
                  ].includes(item.type) && (
                    <>
                      <div className="text-sm">
                        Prefix:
                        {' '}
                        <span translate="no" className="notranslate">{item?.prefix || 'None'}</span>
                      </div>
                      <div className="text-sm">
                        Suffix:
                        {' '}
                        <span translate="no" className="notranslate">{item?.suffix || 'None'}</span>
                      </div>
                    </>
                  )
                }
                {
                  [
                    config.items.types.text.value,
                    config.items.types.textarea.value,
                  ].includes(item.type) && (
                    <div className="text-sm">
                      Max characters:
                      {' '}
                      <span>{item?.max_length || 'None'}</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
}
